import React from 'react';

const Badge = ({
  children,
  variant = 'default',
  size = 'default',
  className = '',
  ...props
}) => {
  const variantClasses = {
    default: 'bg-gray-2 text-body dark:bg-meta-4 dark:text-bodydark',
    primary: 'bg-brand-500/10 text-brand-500',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning',
    danger: 'bg-danger/10 text-danger',
    info: 'bg-brand-500/10 text-brand-500',
    outline: 'bg-transparent border border-stroke text-body dark:border-strokedark dark:text-bodydark',
  };

  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-xs',
    default: 'px-2.5 py-1 text-xs',
    lg: 'px-3 py-1.5 text-sm',
  };

  return (
    <span
      className={`
        inline-flex items-center font-medium rounded-full
        ${variantClasses[variant] || variantClasses.default}
        ${sizeClasses[size] || sizeClasses.default}
        ${className}
      `}
      {...props}
    >
      {children}
    </span>
  );
};

export default Badge;
